'use strict';
import * as $j_com$002eraquo$002eairstream$002ecommon$002e$002dInternal$002dTry$002dObserver from "./com.raquo.airstream.common.-Internal-Try-Observer.js";
import * as $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dSignal from "./com.raquo.airstream.common.-Single-Parent-Signal.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable from "./com.raquo.airstream.core.-Base-Observable.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed from "./com.raquo.airstream.core.-Named.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal from "./com.raquo.airstream.core.-Writable-Signal.js";
import * as $j_com$002eraquo$002eairstream$002edistinct$002e$002dDistinct$002dSignal from "./com.raquo.airstream.distinct.-Distinct-Signal.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_airstream_misc_ScanLeftSignal(parent, makeInitialValue, fn) {
  this.Eq = null;
  this.Ep = false;
  this.Er = null;
  this.yu = 0;
  this.En = null;
  this.Eo = null;
  this.Et = false;
  this.rI = null;
  this.yy = false;
  this.Em = 0;
  this.yx = null;
  this.yw = null;
  this.yv = null;
  this.Es = 0;
  this.yx = parent;
  this.yw = makeInitialValue;
  this.yv = fn;
  this.Eq = (void 0);
  $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  this.yu = 0;
  $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.rI = (void 0);
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dSignal.$f_Lcom_raquo_airstream_common_SingleParentSignal__$init$__V(this);
  this.Es = ((1 + parent.dT()) | 0);
}
export { $c_Lcom_raquo_airstream_misc_ScanLeftSignal as $c_Lcom_raquo_airstream_misc_ScanLeftSignal };
$p = $c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_airstream_misc_ScanLeftSignal;
/** @constructor */
function $h_Lcom_raquo_airstream_misc_ScanLeftSignal() {
}
export { $h_Lcom_raquo_airstream_misc_ScanLeftSignal as $h_Lcom_raquo_airstream_misc_ScanLeftSignal };
$h_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype = $p;
$p.dP = (function() {
  return this.Eq;
});
$p.dd = (function() {
  return $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed.$f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$p.b = (function() {
  return $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed.$f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.gA = (function() {
  return this.Ep;
});
$p.fm = (function() {
  return this.Er;
});
$p.ea = (function(x$1) {
  this.Ep = x$1;
});
$p.gD = (function(x$1) {
  this.Er = x$1;
});
$p.f = (function(obj) {
  return (this === obj);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$systemIdentityHashCode(this);
});
$p.gs = (function() {
  return this.yu;
});
$p.kI = (function(x$1) {
  this.yu = x$1;
});
$p.hm = (function(observer) {
  observer.fY($j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal.$f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this));
});
$p.ew = (function() {
  return this.En;
});
$p.ey = (function() {
  return this.Eo;
});
$p.hw = (function() {
  return this.Et;
});
$p.g1 = (function(x$1) {
  this.Et = x$1;
});
$p.hf = (function(x$0) {
  this.En = x$0;
});
$p.hg = (function(x$0) {
  this.Eo = x$0;
});
$p.l3 = (function() {
  return this.rI;
});
$p.rb = (function(x$1) {
  this.rI = x$1;
});
$p.b3 = (function() {
  return $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal.$f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this);
});
$p.fW = (function(nextValue, transaction) {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dInternal$002dTry$002dObserver.$f_Lcom_raquo_airstream_common_InternalTryObserver__onNext__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.fV = (function(nextError, transaction) {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dInternal$002dTry$002dObserver.$f_Lcom_raquo_airstream_common_InternalTryObserver__onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$p.rc = (function() {
  return this.yy;
});
$p.tQ = (function() {
  return this.Em;
});
$p.kJ = (function(x$1) {
  this.Em = x$1;
});
$p.u2 = (function(x$0) {
  this.yy = x$0;
});
$p.hp = (function() {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dSignal.$f_Lcom_raquo_airstream_common_SingleParentSignal__onWillStart__V(this);
});
$p.ll = (function(nextValue, nextParentLastUpdateId) {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dSignal.$f_Lcom_raquo_airstream_common_SingleParentSignal__updateCurrentValueFromParent__s_util_Try__I__V(this, nextValue, nextParentLastUpdateId);
});
$p.hn = (function() {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dSignal.$f_Lcom_raquo_airstream_common_SingleParentSignal__onStart__V(this);
});
$p.ho = (function() {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dSignal.$f_Lcom_raquo_airstream_common_SingleParentSignal__onStop__V(this);
});
$p.eB = (function() {
  return this.yx;
});
$p.dT = (function() {
  return this.Es;
});
$p.id = (function() {
  if (this.yy) {
    var parentSignal = this.yx;
    var x = this.rI;
    var x$1 = ((x === (void 0)) ? (void 0) : this.yv.bB(x, parentSignal.b3()));
    var default$1 = this.yw;
    return ((x$1 === (void 0)) ? default$1.h() : x$1);
  } else {
    var x$2 = this.rI;
    var default$2 = this.yw;
    return ((x$2 === (void 0)) ? default$2.h() : x$2);
  }
});
$p.fX = (function(nextParentValue, transaction) {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dSignal.$f_Lcom_raquo_airstream_common_SingleParentSignal__onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextParentValue, transaction);
  $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal.$f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, this.yv.bB($j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal.$f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this), nextParentValue), transaction);
});
$p.hi = (function(isSame) {
  return new $j_com$002eraquo$002eairstream$002edistinct$002e$002dDistinct$002dSignal.$c_Lcom_raquo_airstream_distinct_DistinctSignal(this, isSame, false);
});
$p.dS = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_misc_ScanLeftSignal = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_misc_ScanLeftSignal, "com.raquo.airstream.misc.ScanLeftSignal", ({
  h0: 1,
  a1: 1,
  M: 1,
  ai: 1,
  ak: 1,
  au: 1,
  az: 1,
  as: 1,
  aQ: 1,
  aj: 1,
  ay: 1,
  b1: 1
}));
export { $d_Lcom_raquo_airstream_misc_ScanLeftSignal as $d_Lcom_raquo_airstream_misc_ScanLeftSignal };
